import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const intitialState = {
  customers: [],
  buildingCustomers: [],
  entranceCustomers: [],
  notes: [],
  customerById: null,
  customerByCard: null,
  customersLoading: false,
  customerByCardLoading : false,
  customerByCardError: '',
  customersError: '',
  customersPage: 1,
  customersTotalPages: 1,
  buildingCustomersPage: 1,
  buildingCustomersTotalPages: 1,
  entranceCustomersPage: 1,
  entranceCustomersTotalPages: 1,
};

const onCreateCustomer = (state, action) => {
  return updateObject(state, {
    customers: [...state.customers, action.payload],
    buildingCustomers: [...state.buildingCustomers, action.payload],
    entranceCustomers: [...state.entranceCustomers, action.payload],
  });
};

const customersReducer = (state = intitialState, action) => {
  switch (action.type) {
    case AC.GET_CUSTOMERS_REQUEST:
    case AC.GET_BUILDING_CUSTOMERS_REQUEST:
    case AC.GET_ENTRANCE_CUSTOMERS_REQUEST:
    case AC.GET_CUSTOMER_DETAILS_REQUEST:
    case AC.ADD_CUSTOMER_REQUEST:
    case AC.EDIT_CUSTOMER_REQUEST:
    case AC.DELETE_CUSTOMER_REQUEST:
    case AC.ADD_NOTE_REQUEST:
    case AC.GET_NOTES_REQUEST:
    case AC.REACTIVATE_CARD_REQUEST:
      return updateObject(state, {customersLoading: true, customersError: ''});
    case AC.GET_CUSTOMERS_SUCCEED:
      return updateObject(state, {
        customers: action.payload,
        customersPage: action.page,
        customersTotalPages: action.totalPages,
        customersLoading: false,
      });
    case AC.GET_BUILDING_CUSTOMERS_SUCCEED:
      return updateObject(state, {
        buildingCustomers: action.payload,
        buildingCustomersPage: action.page,
        buildingCustomersTotalPages: action.totalPages,
        customersLoading: false,
      });
    case AC.GET_ENTRANCE_CUSTOMERS_SUCCEED:
      return updateObject(state, {
        entranceCustomers: action.payload,
        entranceCustomersPage: action.page,
        entranceCustomersTotalPages: action.totalPages,
        customersLoading: false,
      });
    case AC.GET_CUSTOMER_DETAILS_SUCCEED:
      return updateObject(state, {
        customerById: action.payload,
        customersLoading: false,
      });
    case AC.ADD_CUSTOMER_SUCCEED:
      return onCreateCustomer(state, action);
    case AC.GET_NOTES_SUCCEED:
      return updateObject(state, {
        notes: action.payload,
        customersLoading: false,
      });

    case AC.GET_CUSTOMERS_BY_SITE_REQUEST: 
      return updateObject(state, { customerByCardLoading: true, customerByCardError: '' });

      case AC.GET_CUSTOMERS_BY_SITE_SUCCEED:  
      return updateObject(state, {
        customerByCard: action.payload,
        customerByCardLoading: false,
      });

      case AC.GET_CUSTOMERS_BY_SITE_FAILED:  
      return updateObject(state, {
        customerByCardError: action.payload,
        customerByCardLoading: false,
      });

    case AC.GET_CUSTOMERS_BY_CODE_REQUEST: 
      return updateObject(state, { customerByCardLoading: true, customerByCardError: '' });

      case AC.GET_CUSTOMERS_BY_CODE_SUCCEED:  
      return updateObject(state, {
        customerByCard: action.payload,
        customerByCardLoading: false,
      });

      case AC.GET_CUSTOMERS_BY_CODE_FAILED:  
      return updateObject(state, {
        customerByCardError: action.payload,
        customerByCardLoading: false,
      });
    case AC.GET_CUSTOMERS_FAILED:
    case AC.GET_BUILDING_CUSTOMERS_FAILED:
    case AC.GET_CUSTOMER_DETAILS_FAILED:
    case AC.ADD_CUSTOMER_FAILED:
    case AC.EDIT_CUSTOMER_FAILED:
    case AC.DELETE_CUSTOMER_FAILED:
    case AC.ADD_NOTE_FAILED:
    case AC.GET_NOTES_FAILED:
    case AC.REACTIVATE_CARD_FAILED:
      return updateObject(state, {
        customersError: action.payload,
        customersLoading: false,
      });
    default:
      return state;
  }
};

export default customersReducer;
